
import { MessageSquare } from "lucide-react";
import { Button } from "./ui/button";

export function FloatingChat() {
  // Component is now empty/disabled by default
  return null;
}
